export { useRouter } from 'next/compat/router';
